import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  persistReducer,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { connectionsTableSlice } from "@/features/ConnectionsTable";
import { layoutsSlice, widgetsSlice } from "@/pages/DashboardsPage/slice/state";
import { signUpSlice } from "@/features/sign-up";
import { paymentSlice } from "@/features/payment-form";
import { vcfSlice } from "@/entities/vcf";
import { themeSlice } from "../theme/slice";
import { authSlice } from "../auth/slice";
import { rootApi } from "../api/api";
import { blockingModalActions } from "../blocking-modal";
import { rootReducer } from "./root-reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    themeSlice.name,
    authSlice.name,
    widgetsSlice.name,
    layoutsSlice.name,
    connectionsTableSlice.name,
    paymentSlice.name,
    signUpSlice.name,
    vcfSlice.name,
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          blockingModalActions.setConfirmIsVisible.type,
        ],
      },
    }).concat(rootApi.middleware),
});

export const persistor = persistStore(store);
